export default __webpack_public_path__ + "static/media/products.fa297b14.png";